__webpack_require__.p = "https://cdn.medprev.online/web-app/assets/a37cfd75/_next/";